export default __webpack_public_path__ + "static/media/login-auth-left-panel.6aefa520.png";